import React, { useState,useEffect } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { PlantTable } from "./PlantTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./plantSlice";

export const PlantPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);


  // Filter
  const [plantCode, setPlantCode] = useState("");
  const [plantName, setPlantName] = useState("");
  const [updateUser, setUpdateUser] = useState("");


  const handleSearch = () => {
    const params = {
      plantCode: plantCode,
      plantName: plantName,
      updateUser: updateUser,
      pageNo: pageNo,
      pageSize: pageSize,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      plantCode: plantCode,
      plantName: plantName,
      updateUser: updateUser,
      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Plant"></CardHeader>
      <CardBody>
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Plant Code</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Plant Code"
                    onChange={(e) => {
                      setPlantCode(e.target.value);
                    }}
                    value={plantCode}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Plant Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Plant Name"
                    onChange={(e) => {
                      setPlantName(e.target.value);
                    }}
                    value={plantName}
                  />
                </Col>
              </Form.Group>
              
            </Col>

            {/* Right Row */}
            <Col sm={6}>
            <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>UpdateUser</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="UpdateUser"
                    onChange={(e) => {
                      setUpdateUser(e.target.value);
                    }}
                    value={updateUser}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Col>
              <Button className="btn btn-primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        {data.length > 0 && (
          <PlantTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
